import { Sparkles, X } from 'lucide-react';

export function ComingSoonCallout({ show, onDismiss }: { show: boolean; onDismiss: () => void }) {
  if (!show) return null;
  return (
    <div
      role="status"
      className="flex items-start gap-3 rounded-[14px] border border-[#c4b5fd] bg-[#f5f3ff] px-4 py-3 text-sm text-[#6d28d9]"
    >
      <Sparkles className="mt-0.5 size-4 shrink-0" />
      <p className="flex-1 leading-5">
        Community is coming soon — ask questions, share notes, and collaborate with your batch.
      </p>
      <button
        type="button"
        onClick={onDismiss}
        aria-label="Dismiss"
        className="mt-0.5 shrink-0 text-[#8b5cf6] hover:text-[#6d28d9]"
      >
        <X className="size-4" />
      </button>
    </div>
  );
}
